import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=31324cce&scoped=true"
var script = {}
import style0 from "./loading-spinner.vue?vue&type=style&index=0&id=31324cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31324cce",
  null
  
)

export default component.exports